<template>
  <div class="data-migration-server-list">
    <common-bg-plate>
      <div class="add-server-config">
        <btn-style :btn-list="btnList"></btn-style>
        <div class="add-server-config-hint">若已部署，请在此添加服务器配置进行调用测试</div>
      </div>
      <normal-table
        ref="commonTable"
        :table-col="tableCol"
        :table-data="serverList"
        :operator="operator"
        :operate-col="operateCol"
        :paging="serverPaging"
        :show-edit="true"
        @pagination="handleSizeOrPageChange"
      >
      </normal-table>
      <add-server-config ref="addServerDialog" @getList="getList"></add-server-config>
    </common-bg-plate>
  </div>
</template>

<script>
import addServerConfig from './addServerConfig'
import { mapState, mapActions } from 'vuex'
export default {
  name: 'ServerList',
  components: {
    addServerConfig
  },
  data() {
    return {
      btnList: [
        {
          btnContent: '添加服务器配置',
          click: () => {
            return this.addServerConfig()
          },
          icon: 'icon-gen'
        }
      ],
      // 设置table的列
      tableCol: [
        {
          prop: 'ip',
          label: '服务器IP',
          minWidth: 284
        },
        {
          prop: 'servername',
          label: '服务器名称',
          minWidth: 320
        },
        {
          prop: 'serverport',
          label: '服务端口',
          minWidth: 143
        },

        {
          prop: 'createAt',
          label: '创建时间',
          formatter: row => {
            return this.formatTime(row)
          },
          minWidth: 260
        }
      ],
      // table的基本操作
      operator: [
        {
          text: '进入迁移',
          click: (row, col, cellValue) => {
            return this.linkTo(row)
          },
          showText: true,
          icon: 'icon-migration'
        },
        {
          showText: true,
          text: '删除',
          icon: 'icon-cancel',
          click: (row, col, cellValue) => {
            return this.delServer(row)
          }
        }
      ],
      operateCol: {
        minWidth: 160
      }
    }
  },
  computed: {
    ...mapState({
      serverList: state => state.excellent.server_list,
      serverPaging: state => state.excellent.server_paging
    })
  },
  mounted() {
    this.getList()
  },
  methods: {
    ...mapActions(['encryptConfigList']),
    getList(limit = 10, offset = 0, name) {
      let formObj = {}
      formObj.userid = '1'
      formObj.source = 'data_transfer'
      formObj.limit = limit
      formObj.offset = offset

      this.encryptConfigList(formObj)
    },
    handleSizeOrPageChange(data) {
      const { offset, limit } = data
      this.getList(limit, offset * limit)
    },
    formatTime(row) {
      return this.$utils.dateFormat('YYYY-mm-dd HH:MM', row.createAt)
    },
    addServerConfig() {
      let data = {
        title: '添加服务器配置'
      }
      this.$refs.addServerDialog.handleOpen(data)
    },

    linkTo(row) {
      let serviceAddress = `${row.ip}:${JSON.parse(row.encryptsvrs)[0].serverport}`
      this.$router.push({
        name: 'dataMigrationList',
        query: {
          serviceAddress: serviceAddress
        }
      })
    },
    delServer(row) {
      this.$confirm('此操作将删除服务配置, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let formObj = {}
          formObj.ip = row.ip
          this.$apis.excellent.encryptConfigDel(formObj).then(res => {
            if (res) {
              this.$message.success('删除成功')
              this.getList()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
@include theme(
  'data-migration-server-list',
  (
    --data-migration-server-list-add-server-config-hint-color: #ffffff,
    --data-migration-server-list-operate-color: #45c2ff
  ),
  (
    --data-migration-server-list-add-server-config-hint-color: #192227,
    --data-migration-server-list-operate-color: #45c2ff
  )
);
.data-migration-server-list {
  @include adaptation(
    (
      --data-migration-server-list-unavailable-height: 610px,
      --data-migration-server-list-padding: 16px 16px 0 16px,
      --data-migration-server-list-padding-top: 16px,
      --data-migration-server-list-add-server-config-height: 32px,
      --data-migration-server-list-add-server-config-margin-bottom: 16px,
      --data-migration-server-list-add-server-config-hint-margin-left: 12px
    )
  );
  --data-migration-server-list-min-height: calc(
    var(--base-main-router-body-avaliable-height) - var(--data-migration-server-list-unavailable-height)
  );
  --data-migration-server-list-table-min-height: calc(
    var(--base-main-router-body-avaliable-height) - var(--data-migration-server-list-unavailable-height) -
      var(--data-migration-server-list-padding-top) -
      var(--data-migration-server-list-add-server-config-height) -
      var(--data-migration-server-list-add-server-config-margin-bottom)
  );
  .common-bg-plate {
    padding: var(--data-migration-server-list-padding);
    min-height: var(--data-migration-server-list-min-height);

    .add-server-config {
      display: flex;
      align-items: center;
      margin-bottom: var(--data-migration-server-list-add-server-config-margin-bottom);

      .add-server-config-hint {
        color: var(--data-migration-server-list-add-server-config-hint-color);
        margin-left: var(--data-migration-server-list-add-server-config-hint-margin-left);
      }
    }

    .normal-table-wrap {
      height: 100%;
      min-height: var(--data-migration-server-list-table-min-height);

      /deep/ {
        .el-empty {
          height: 100%;
          min-height: var(--data-migration-server-list-table-min-height);
        }

        .normal-table {
          height: 100%;
          min-height: var(--data-migration-server-list-table-min-height);

          .operate-item {
            color: var(--data-migration-server-list-operate-color);
          }
        }
      }
    }
  }
}
</style>
